<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/14m3Pgn/tc-custom/9781847675095.jpg?1703851147224" alt="This image is the cover for the book Private Angelo, Canongate Classics"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Private Angelo, Canongate Classics
      </h1>
      <p class="bookDescription body article font2">
        <b>This satirical novel of a young innocent caught in the fascist machinery of WWII offers “the drollest medley of muddle and misadventure” (<i>The Sunday Times</i>, UK).</b><br/>  <br/> A private in Mussolini’s ‘ever-glorious’ Italian army, Angelo may possess the virtues of love and innocence, but he lacks the gift of courage. And yet, due to circumstances beyond his control, he ends up fighting not only for Italy but also for the British and German armies. Through the shifting winds of war, as well as marriage and romance, Angelo’s most enduring quality may be his talent for survival. Told with humor, insight and sympathy, Angelo’s tale is a wittily satirical comment on the grossness and waste of war.<br/>  <br/> Eric Linklater, who served with the Black Watch in Italy during World War II, is one of Scotland’s most distinguished writers. In <i>Private Angelo</i> he has written a book which demonstrates that honor is not solely the preserve of the brave.<br/>  <br/><b>“He writes not only of an angel, but like one . . . <i>Private Angelo</i> is now a permanent portrait in the heavenly gallery of human futility.” —<i>The Observer</i>, UK</b><br/>  <br/><b>“A quite unforgettable group of people take part, none of whom lacks the genuine Linklater stamp . . . A high-spirited entertainment which never loses its individual air.” —<i>The Sunday Times</i>, UK</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Eric Linklater, Magnus Linklater
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Canongate
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?76cb1ca6